import React from 'react';

function QuestionInputNumber(props: {
    placeholder: string;
    value: string;
    setValue: (v: string) => void;
    onChange: (e: React.ChangeEvent) => void;
}): JSX.Element {
    const { placeholder, onChange } = props; 

    // 숫자만 입력 받기
    let { value } = props;
    value = value.replace(/[^0-9]/g,'');

    return <input type="text" id="textField_text" value={value} onChange={onChange} placeholder={placeholder} />;
}

export default QuestionInputNumber;